/* eslint no-console: 0 */

import { createApp } from 'vue'
import App from './src/guest/current_guests/show.vue'

document.addEventListener('DOMContentLoaded', () => {
  const elementSelector = '#vuejs_space'
  const props = JSON.parse(document.querySelector(elementSelector).dataset.props)
  createApp(App, props).mount(elementSelector)
})
